import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { CartProvider } from "./Component/Pages/CartContext";
// import { CartProvider } from "./CartContext";
 // ✅ Import CartProvider

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <CartProvider>
      <App />

      </CartProvider>
  </React.StrictMode>
);
